import React, { FC, useContext, useState } from 'react'
import { Trans } from '@lingui/macro'

import CampaignLinkReportOverviewTable from './CampaignLinkReportOverviewTable'
import CampaignLinkReportFilters from './CampaignLinkReportFilters'
import { ButtonPrimary } from 'front-end/src/components'
import IconEmptyLinkReports from 'public/assets/img/empty-link-reports.svg'
import '../campaign-action-reports/CampaignActionReport.less'
import './CampaignLinkReport.less'
import { ManageCampaignContext } from '../ManageCampaignPage'
import { SqlOrderDirectionEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { IconFilter } from 'front-end/src/components/common/icon/IconFilter'
import { CampaignActionTypeEnum } from 'shared/enums/campaigns'

export type SelectedActions = Array<{
  id: number
  type: CampaignActionTypeEnum
}>

export interface ICampaignLinkReportsFilters {
  search: string
  selectedActions: SelectedActions
  sort: SqlOrderDirectionEnum
  page: number
}

export const CampaignLinkReport: FC = () => {
  const { campaign } = useContext(ManageCampaignContext)
  const [filters, setFilters] = useState<ICampaignLinkReportsFilters>({
    page: 0,
    sort: SqlOrderDirectionEnum.ASC,
    selectedActions: [],
    search: ''
  })

  const [showActionsFilterModal, setShowActionsFilterModal] =
    useState<boolean>(false)

  const mergeAndSetFilters = (
    newFilters: Partial<ICampaignLinkReportsFilters>
  ) => {
    setFilters({ ...filters, ...newFilters })
  }

  if (
    !campaign.is_active &&
    !campaign.wasCampaignDeactivated &&
    !campaign.track_links
  ) {
    // Campaign that was not activated yet
    return (
      <div className="CampaignLinkReports__guide">
        <h2>
          <Trans>Tracking links is deactivated</Trans>
          <span>
            <Trans>You can activate that in the campaign settings.</Trans>
          </span>
        </h2>
      </div>
    )
  }

  if (!campaign.track_links && campaign.is_active) {
    return (
      <div className="CampaignLinkReports__guide">
        <h2>
          <Trans>Tracking links is deactivated</Trans>
          <span>
            <Trans>
              Tracking links can not be activated in campaign that is already in
              progress.
            </Trans>
          </span>
        </h2>
      </div>
    )
  }

  return (
    <div className="CampaignReports">
      <section className="CampaignReports__filters">
        <CampaignLinkReportFilters
          filters={filters}
          onFilterChange={mergeAndSetFilters}
          showActionsFilterModal={showActionsFilterModal}
          setShowActionsFilterModal={setShowActionsFilterModal}
        />
      </section>
      <section className="CampaignReports__overview">
        {filters.selectedActions.length > 0 ? (
          <CampaignLinkReportOverviewTable
            onFilterChange={mergeAndSetFilters}
            filters={filters}
          />
        ) : (
          <div className="CampaignLinkReports__guide">
            <img src={IconEmptyLinkReports} alt="IconEmptyLinkReports" />
            <h2>
              <Trans>Please select a specific action</Trans>
              <span>
                <Trans>
                  Filtering by action is required to display the link reports
                </Trans>
              </span>
            </h2>
            <ButtonPrimary
              onClick={() => setShowActionsFilterModal(true)}
              leftIcon={<IconFilter />}
            >
              <Trans>Set filter</Trans>
            </ButtonPrimary>
          </div>
        )}
      </section>
    </div>
  )
}
